var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4982 21.8918H12.4345C12.1378 21.8909 11.8446 21.828 11.574 21.7071C11.3034 21.5861 11.0613 21.41 10.8636 21.1899L2.46696 12.5489C2.3708 12.4533 2.3071 12.3576 2.21095 12.262C0.977027 10.836 0.361699 8.98148 0.499804 7.10494C0.637909 5.2284 1.51818 3.48284 2.94773 2.25079C4.30055 1.15676 6.02177 0.616955 7.76073 0.74136C9.4997 0.865764 11.1256 1.64501 12.3071 2.92036L12.4994 3.11166L12.7242 2.88807C13.9081 1.62812 15.5265 0.859191 17.2557 0.735051C18.985 0.610912 20.6976 1.14071 22.0511 2.21851C22.0835 2.25079 22.1148 2.25079 22.1148 2.28188C22.1785 2.34525 22.2746 2.40981 22.3395 2.47318C23.0194 3.11462 23.5626 3.88549 23.937 4.73996C24.3113 5.59443 24.5091 6.51505 24.5186 7.44709C24.5532 9.33127 23.8393 11.153 22.5319 12.5167L14.1328 21.1899L14.0691 21.2533C13.647 21.6584 13.0847 21.887 12.4982 21.8918V21.8918Z",
    fill: "#FF417D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartP);
export default __webpack_public_path__ + "static/media/heart_p.1f6617fc1248d779ae139e642c68a5db.svg";
export { ForwardRef as ReactComponent };